import React from "react";
import { PageShell, EditableSection, EditableFeatureGrid } from "./PageShell";

const STEPS = [
  { badge: "01", title: "Composition", body: "Each fragrance is built around a French-inspired accord — a deliberate balance of top, heart, and base notes chosen for the impression it leaves." },
  { badge: "02", title: "Blending", body: "Ingredients are combined in precise ratios and rested so the raw notes marry into a single, harmonious voice." },
  { badge: "03", title: "Maturation", body: "Batches rest in sealed amber vessels before bottling. This resting period allows sharp edges to soften and the true character of the fragrance to emerge." },
  { badge: "04", title: "Quality control", body: "Every batch is scent-tested and inspected for clarity, colour, and consistency before it moves to the bottling stage." },
  { badge: "05", title: "Hand-pouring in Canada", body: "Each bottle is filled by hand at our Canadian atelier, capped, sealed, and set aside for a final visual review." },
  { badge: "06", title: "Presentation", body: "Bottles are wiped clean, matched to their carton, and packed with care — ready to become your next signature." },
];

const BANNER = [{
  heading: "French-Inspired Fragrance Notes · Hand-Poured with Love in Canada",
  body: "Our compositions draw from the French tradition of layered perfumery, while every bottle is finished by hand at our Canadian atelier. It’s the marriage we chose: classical scent structure, modern craftsmanship, and a direct line from maker to wearer.",
}];

export default function CraftPage() {
  return (
    <PageShell
      slug="craft"
      testid="craft"
      eyebrow="The Craft"
      title="How a Scentodore is made."
      intro="From accord to sealed bottle, each fragrance moves through six deliberate stages. There are no shortcuts, and nothing is left to chance."
    >
      <EditableSection slug="craft" sectionKey="banner" fallback={BANNER} />
      <div className="mb-14">
        <h2 className="font-serif text-xl sm:text-2xl text-[#1A1918] mb-4">The six stages</h2>
        <EditableFeatureGrid slug="craft" sectionKey="steps" fallback={STEPS} />
      </div>
    </PageShell>
  );
}
